import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
      <path d="M10.6673 1.33325V3.99992M5.33398 1.33325V3.99992" stroke="#24D3BA" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 10.0001V8.00008C14 5.48592 14 4.22885 13.2189 3.44779C12.4379 2.66675 11.1808 2.66675 8.66667 2.66675H7.33333C4.81917 2.66675 3.5621 2.66675 2.78105 3.44779C2 4.22885 2 5.48592 2 8.00008V9.33341C2 11.8475 2 13.1047 2.78105 13.8857C3.5621 14.6667 4.81917 14.6667 7.33333 14.6667H8.66667" stroke="#24D3BA" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 6.66675H14" stroke="#24D3BA" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.0007 12.3333H9.33398" stroke="#24D3BA" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default SvgComponent
